import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import EmergencyFundInvestorGoalCalculatorHttpRepository
  from './infrastructure/repositories/emergency-fund-investor-goal-calculator-http-repository';

// Application
import GetEmergencyFundInvestorGoalCalculatorQuery
  from './application/queries/get-emergency-fund-investor-goal-calculator-query';
import CalculateEmergencyFundGoalMaximumMonthsQuery
  from './application/queries/calculate-emergency-fund-goal-maximum-months-query';

// Domain
import { EmergencyFundInvestorGoalCalculatorRepository }
  from './domain/repositories/emergency-fund-investor-goal-calculator-repository';

export default function setupEmergencyFundInvestorGoalCalculator(container: Container) {
  container
    .bind<EmergencyFundInvestorGoalCalculatorRepository>(TYPES
      .EMERGENCY_FUND_INVESTOR_GOAL_CALCULATOR_REPOSITORY)
    .to(EmergencyFundInvestorGoalCalculatorHttpRepository)
    .inSingletonScope();

  container.bind<GetEmergencyFundInvestorGoalCalculatorQuery>(TYPES
    .GET_EMERGENCY_FUND_INVESTOR_GOAL_CALCULATOR_QUERY)
    .to(GetEmergencyFundInvestorGoalCalculatorQuery)
    .inSingletonScope();

  container.bind<CalculateEmergencyFundGoalMaximumMonthsQuery>(TYPES
    .CALCULATE_EMERGENCY_FUND_GOAL_MAXIMUM_MONTHS_QUERY)
    .to(CalculateEmergencyFundGoalMaximumMonthsQuery)
    .inSingletonScope();
}
